import React, { createContext} from 'react'

export const pixContext = createContext({})
export const themeContext = createContext({})